@if (trainings==null || users==null || labels == null || departments == null || successfulTrainings == null) {
  <app-admin-spinner></app-admin-spinner>
}
<div class="row" style="margin: auto; text-align: center">
  <div class="col-12 col-sm-3" style="margin: auto; margin-top:1vh !important; background-color: #182038; border:1px solid #182038; border-radius:5px;">
    <div class="row">
      <div class="col-12" style="text-align:center; margin: auto">
        <h1 style="color: #3e4b71;
        font-family: 'Prompt', sans-serif;">{{labels.lblUsers}}</h1>
      </div>
      <div class="col-12" style="text-align:center; margin: auto">
        <h1 style="color: #8293c6;
        font-family: 'Prompt', sans-serif; font-size: 35px;">{{users?.length}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3" style="margin: auto;margin-top:1vh !important; background-color: #182038; border:1px solid #182038; border-radius:5px;">
    <div class="row">
      <div class="col-12" style="text-align:center; margin: auto">
        <h1 style="color: #3e4b71;
        font-family: 'Prompt', sans-serif;">{{labels.lblSectors}}</h1>
      </div>
      <div class="col-12" style="text-align:center; margin: auto">
        <h1 style="color: #8293c6;
        font-family: 'Prompt', sans-serif; font-size: 35px;">{{departments?.length}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3" style="margin: auto; margin-top:1vh !important;  background-color: #182038; border:1px solid #182038; border-radius:5px;">
    <div class="row">
      <div class="col-12" style="text-align:center; margin: auto">
        <h1 style="color: #3e4b71;
        font-family: 'Prompt', sans-serif;">{{labels.lblTrainings}}</h1>
      </div>
      <div class="col-12" style="text-align:center; margin: auto">
        <h1 style="color: #8293c6;
        font-family: 'Prompt', sans-serif; font-size: 35px;">{{trainings?.length}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 typeLabel" style="margin: auto; margin-top:1vh !important; margin-bottom: 0px;  background-color: #1494f9; border:1px solid #1494f9; border-radius:5px;">
    <div class="row">
      <div class="col-12" style="text-align:center; margin: auto">
        @if (admin?.companyId) {
<h1 style="color: #3e4b71;
        font-family: 'Prompt', sans-serif; margin-top: 5% !important; margin-bottom: 5% !important;">@if (admin.isAdmin == true) {
            <span>
              @if (admin.companyId == 4) {
                <span>RGZ</span>
              }
            </span>
            }@if (admin.isAdmin == false) {
            <span>Trener kompanija</span>
          }</h1>
        }
      </div>
    </div>
  </div>

</div>

<br>

  <mat-divider></mat-divider>

  <br>

    <div class="row" style="">
      <div class="col-12 col-xl-2" style="">
        <app-status-pie [selectedTraining]="[]">

        </app-status-pie>
      </div><br>
      <div class="col-12 col-xl-5" style="">
        <app-widget-pie>

        </app-widget-pie>
      </div><br><br>
      <div class="col-12 col-xl-2" style="margin: auto !important;">
        <app-apex-chart>

        </app-apex-chart>
      </div>
      <div class="col-12 col-xl-2" style="margin: auto !important; ">
        <app-test-success-pie>

        </app-test-success-pie>
      </div>


    </div>
